const toastOptions = (options) => {
  return {
    autoClose: 5000,
    hideProgressBar: false,
    pauseOnHover: true,
    ...options
  }
}

export const doToast = ({ response = '', message = '', toast = {}, options = {} }) => {
  if (response === 'success') {
    toast.success(message, toastOptions(options))
  } else if (response === 'info') {
    toast.info(message, toastOptions(options))
  } else if (response === 'warning') {
    toast.warning(message, toastOptions(options))
  } else {
    toast.error(message, toastOptions(options))
  }
}